import React from 'react';
import { Link } from 'react-router-dom';
import ReactLoading from 'react-loading';
import { connect } from 'react-redux';
import { history } from '../../store/configureStore';
import { bindActionCreators } from 'redux';
import * as SVGICONS from '../../images/img/images';

// import Moment from 'react-moment';
// import Modal from 'react-modal';
import DocumentUpload from '../documentupload/documentUpload';
import moment from 'moment';
import * as appointmentActions from '../../actions/appointmentActions';
import * as documentUploadActions from '../../actions/documentUploadActions';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'
import validator from './../common/validator.js';
import AppointmentDocs from '../sitemanagement/appointmentDocs';

import $ from 'jquery';
const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',

	},
	symptomsTxt: {
		height: 150
	}
};

class AppointmentDetails extends React.Component {
	constructor(props, context) {
		super(props, context);
		let user = JSON.parse(localStorage.getItem('user'));
		this.state = {};
		this.state = {
			openDocumentModal: false,
			isLoader: true,
			appointmentDetailsData: {},
			gender: user.gender,
			mode: '2',
			symptoms: '',
			userName: user.userName,
			dateOfBirth: user.dateOfBirth,
			spinner: false,
			userTypeData: [],
			uploadedImages: [],
			uploadedFileOriginalName: '',
			appointmentDetails: [],
			// file: '',
			// documentName: '',
			// documentTypeId: '',

			file: { value: '', isValid: true, message: '' },
			documentName: { value: '', isValid: true, message: '' },
			documentTypeId: { value: '', isValid: true, message: '' },
		}
		// // this.openModal = this.openModal.bind(this);
		this.openModal = this.openModal.bind(this);
		this.hideDocumentModal = this.hideDocumentModal.bind(this);
		// this.closeModal = this.closeModal.bind(this);
		this.hidedocModal = this.hidedocModal.bind(this);

		this.addAppointment = this.addAppointment.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onChangeDocument = this.onChangeDocument.bind(this);
		this.uploadDocument = this.uploadDocument.bind(this);
		this.deleteDocument = this.deleteDocument.bind(this);
		this.cancelAppointment = this.cancelAppointment.bind(this);
		this.reSetModal = this.reSetModal.bind(this);
		this.resetValidationStates = this.resetValidationStates.bind(this);

			}

	componentWillMount() {
		let user = JSON.parse(localStorage.getItem('user'));
		let appointmentId = this.props.location.data ?  this.props.location.data.appointmentId : localStorage.getItem('appointmentId');
		localStorage.setItem('appointmentId', appointmentId);
		console.log("this.props.location.data", this.props.location, this.props.location.data)
		this.setState({
			isLoader: false
		})
		let objectDocumentType = {
			userType: user.type
		}
		let objectDocument = {
			appointmentId
		}
		if (localStorage.getItem('appointmentId') || appointmentId) {
			this.props.appointmentactions.getAppointmentDetails(objectDocument)
		}
		this.props.actions.getDocumentType(objectDocumentType);
		this.props.actions.getAppointmentDocument(objectDocument);
	}

	componentWillReceiveProps(nextProps) {
		console.log("change in props")
		if (nextProps.appointmentDetails) {
			this.setState({
				//	symptoms: nextProps.appointmentDetails.symptoms
			})
		}
		this.setState({
			userTypeData: nextProps.userTypeData,
			uploadedImages: nextProps.uploadedImages ? nextProps.uploadedImages : [],
			openDocumentModal: false,
			isLoader: false,
			spinner: false,
			file: { value: '', isValid: true, message: '' },
			documentName: { value: '', isValid: true, message: '' },
			documentTypeId: { value: '', isValid: true, message: '' }

		})
	}
	appointmentDocuments(data) {
		this.setState({ docModal: true, appointmentId: data.appointmentId, patientId: localStorage.getItem('userId') })
		let appointmentObj = {
			appointmentId: data.appointmentId,
		};
	}
	uploadDocument(event) {
		event.preventDefault();
		var state = this.state;

		// if (!validator.isValid(parseInt(state.userType.value))) {
		// 	state.userType.isValid = false;
		// 	state.userType.message = 'Please select user type';
		// } else {
		// 	state.userType.isValid = true;
		// 	state.userType.message = '';
		// }
		if (!validator.isValid(state.file.value)) {
			state.file.isValid = false;
			state.file.message = 'Document is required';
			this.setState({ file: { value: '', isValid: false, message: 'Document is required' } });
		} else {
			state.file.isValid = true;
			state.file.message = '';
			this.setState({ file: { value: state.file.value, isValid: true, message: '' } });
		}
		if (!validator.isValid(state.documentName.value)) {
			state.documentName.isValid = false;
			state.documentName.message = 'Document name is required';
			this.setState({ documentName: { value: '', isValid: false, message: 'Document name is required' } });
			// this.setState(state);
		} else {
			state.documentName.isValid = true;
			state.documentName.message = '';
			this.setState({ documentName: { value: state.documentName.value, isValid: true, message: '' } });

		}
		if (!validator.isValid(state.documentTypeId.value)) {
			state.documentTypeId.isValid = false;
			state.documentTypeId.message = 'Document type is required';
			this.setState({ documentTypeId: { value: '', isValid: false, message: 'Document type is required' } });

			// this.setState(state);
		} else {
			state.documentTypeId.isValid = true;
			state.documentTypeId.message = '';
			this.setState({ documentTypeId: { value: state.documentTypeId.value, isValid: true, message: '' } });

		}
		if (this.state.file.value != '' && this.state.documentName.value != '' && this.state.documentTypeId.value != '' && (this.state.file.message == '' || this.state.file.message == undefined) && (this.state.documentName.message == '' || this.state.documentName.message == undefined) && (this.state.documentTypeId.message == '' || this.state.documentTypeId.message == undefined)) {
			let uploadDocumentObj = {
				appointmentId: localStorage.getItem('appointmentId'),
				patientId: localStorage.getItem('userId'),
				documentName: this.state.documentName.value,
				documentTypeId: this.state.documentTypeId.value,
				file: this.state.file.value
			}
			this.setState({ spinner: true, uploadedFileOriginalName: '' })
			this.props.actions.uploadDocument(uploadDocumentObj, this.props);

		}
	}



	reSetModal() {
		var state = this.state
		this.setState({
			file: { value: '', isValid: true, message: '' },
			documentName: { value: '', isValid: true, message: '' },
			documentTypeId: { value: '', isValid: true, message: '' },
			uploadedFileOriginalName: ''
		})
		document.getElementById('documentName').value = ''
		document.getElementById('documentTypeId').value = ''
		document.getElementById('fileID').value = ''
	}

	openModal() {
		this.setState({ openDocumentModal: true });
	}


	hideDocumentModal() {
		this.setState({ openDocumentModal: false, uploadedFileOriginalName: '' });
	}


	deleteDocument(docs) {
		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to delete ' + docs.documentOriginalName + '?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						let appointmentId = localStorage.getItem('appointmentId');
						let documentId = docs._id
						this.props.actions.deleteDocument(appointmentId, documentId);
					}
				},
				{
					label: 'No',
					onClick: () => { history.push('/appointment-details'); }
				}
			]
		})

	}

	onChange(event) {
		if (event.target.name == 'file') {
			this.setState({ [event.target.name]: event.target.files[0] });

		} else {
			this.setState({ [event.target.name]: event.target.value });
		}
	}

	onChangeDocument(event) {
		var state = this.state;
		if (event.target.name == 'file') {
			state[event.target.name].value = event.target.files[0];
			state.uploadedFileOriginalName = event.target.files[0].name;
		} else {
			state[event.target.name].value = event.target.value;
		}
		this.setState(state);

		this.resetValidationStates();
		if (event.target.name == "file") {
			if (event.target.files.length > 0) {
				if (!validator.fileValidateFormate(event.target.files[0])) {
					state.file.isValid = false;
					state.file.message = 'Please choose following format jpeg, jpg, png, gif, pdf, txt, doc, docx, xls,xlsx';
					// this.setState(state);
					this.setState({ file: { value: '', isValid: false, message: 'Please choose following format jpeg, jpg, png, gif, pdf, txt, doc, docx, xls,xlsx' } });
					// return true
				} else if (!validator.fileValidateSize(state.file.value)) {
					state.file.isValid = false;
					state.file.message = 'Docs Size too large max size 10 mb';
					// this.setState(state);
					this.setState({ file: { value: '', isValid: false, message: 'Docs Size too large max size 10 mb' } });
				} else {
					this.setState({ file: { value: event.target.files[0], isValid: true, message: '' } });

					return true
				}
			} else {

				state.file.isValid = false;
				state.file.message = 'Document is required';
				this.setState({ file: { value: '', isValid: false, message: 'Document is required' } });

				// this.setState(state);
			}

		} else if (event.target.name == "documentName") {

			if (event.target.value.length > 0) {
				if (!validator.isValid(state.documentName.value)) {
					state.documentName.isValid = false;
					state.documentName.message = 'Not a valid Document name';
					// this.setState(state);
					this.setState({ documentName: { value: '', isValid: false, message: 'Not a valid Document name' } });

				} else {
					this.setState({ documentName: { value: state.documentName.value, isValid: true, message: '' } });

					return true
				}
			} else {
				state.documentName.isValid = false;
				state.documentName.message = 'Document name is required';
				this.setState({ documentName: { value: '', isValid: false, message: 'Document name is required' } });

			}
		} else if (event.target.name == "documentTypeId") {

			if (event.target.value.length > 0) {
				if (!validator.isValid(state.documentTypeId.value)) {
					state.documentTypeId.isValid = false;
					state.documentTypeId.message = 'Not a valid Document type';
					// this.setState(state);
					this.setState({ documentTypeId: { value: '', isValid: false, message: 'Not a valid Document type' } });

				} else {
					this.setState({ documentTypeId: { value: state.documentTypeId.value, isValid: true, message: '' } });
					return true
				}
			} else {

				state.documentTypeId.isValid = false;
				state.documentTypeId.message = 'Document type is required';
				// this.setState(state);
				this.setState({ documentTypeId: { value: '', isValid: false, message: 'Document type is required' } });

			}
		}
		// this.setState(state);
		// if (event.target.name == 'file') {
		// 	this.setState({ [event.target.name]: event.target.files[0] });
		// } else {
		// 	this.setState({ [event.target.name]: event.target.value });
		// }
	}

	resetValidationStates() {
		var state = this.state;
		Object.keys(state).map(key => {
			if (state[key] && state[key].hasOwnProperty('isValid')) {
				state[key].isValid = true;
				state[key].message = '';
				// state[key].value = '';
			}
		});
		this.setState(state);
	}

	addAppointment(event) {

		$('textarea').val().replace(/\n/g, '<br>');
		event.preventDefault()
		this.setState({ spinner: true })
		let symptoms = this.state.symptoms ? this.state.symptoms : document.getElementById("fake-file-input-name").value;
		let appointmentMode = this.state.mode;
		let appointmentId = localStorage.getItem('appointmentId');
		let clinetlocation = localStorage.getItem('clinicCountryZone') ? localStorage.getItem('clinicCountryZone') : 'Europe/London';
		var userlocation = moment.tz.guess();
		localStorage.setItem('userlocation', userlocation);
		let availabilityId = localStorage.getItem('availabilityId');
		let addAppointmentObj = {
			symptoms: symptoms,
			appointmentMode: appointmentMode,
			appointmentId: appointmentId,
			clientlocation: clinetlocation,
			userlocation: userlocation,
			userCreatedBy: this.props.location.data ? this.props.location.data.appointmentId ? 'S' : 'O' : 'O'
		};
		this.setState({
			symptoms: ' '
		})
		if (localStorage.getItem('appointmentId')) {
			addAppointmentObj.appointmentId = localStorage.getItem('appointmentId');
		}
		console.log("APPOINTMENTID", addAppointmentObj)
		this.props.appointmentactions.addAppointmentDetails(addAppointmentObj, this.props);
	}

	cancelAppointment() {
		let cancelAppointmentObj = {
			appointmentId: localStorage.getItem('appointmentId')
		}
		this.props.appointmentactions.cancelAppointment(cancelAppointmentObj);


	}

	hidedocModal() {
		this.setState({ docModal: false })
	}



	render() {
		var uploadedImages = this.state.uploadedImages;
		var userTypeData = this.state.userTypeData;
		var isF2FDisabled = localStorage.getItem('clinicCountryZone') != moment.tz.guess()
		console.log("moment guess",moment.tz.guess())
		return (

			<div className="content-wrapper" >
				{
					this.state.isLoader ? <div className="loaderCenter"> <ReactLoading type={'bars'} color={'blue'} /></div> :
						<section className="content container-fluid">

							<div className="row">
								<div className="col-md-12">
									<div className="boxMrgB">
										<div className="nav-tabs-custom">
											<ul className="nav nav-tabs">
												<li className="active"><Link href="#tab_1" data-toggle="tab" className="active show">Appointment Details</Link></li>
												<li className=" col-md">
													<div className="content-header"><ol className="breadcrumb">
														<li><Link> Book Appointment</Link></li>
														<li><Link to="/book-appointment">Search Specialist</Link></li>
														<li><Link to="/book-appointment-calendar">Calendar</Link></li>
														<li className="active">Appointment Details</li>
													</ol></div>

												</li>
											</ul>
											<div className="tab-content">
												<form className="appointmentDetaile-form" id="appointmentDetaileForm" onSubmit={this.addAppointment.bind(this)}>
													<div className="tab-pane active" id="tab_1">
														<div className="settingInput appointmentBox">
															<div className="row">

																<div className="col-md-6">
																	<div className="boxMrgB">
																		<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img//user_input_icon.svg')} alt="" /></i></span>
																			<input type="" className="form-control capitalize" placeholder="Enter Name" value={this.state.userName} disabled />
																		</div>
																	</div>
																</div>

																<div className="col-md-6">
																	<div className="boxMrgB">
																		<div className="input-group date inputBg">
																			<div className="input-group-addon"> <i className="fa "><img src={require('../../images/img//date_input_icon.svg')} alt="" /></i> </div>
																			<input type="text" className="form-control pull-right" id="datepicker" value={moment(this.state.dateOfBirth).format('DD-MMM-YYYY')} disabled placeholder="Select Date of Birth" />
																		</div>
																	</div>
																</div>
																<div className="col-lg-6 col-md-12 col-sm-12 offsettablet offset-lg-3">
																	<div className="row">
																		<div className="col-md-2">
																			<div className="genderInfo ">Mode</div>
																		</div>
																		<div className="col-md-5">
																			<div className="boxMrgB boxMrgT">
																				<div className="radio radio-primary">
																					<input type="radio" name="mode" id="radio3" disabled={isF2FDisabled} onChange={this.onChange} value="1" checked={this.state.mode === '1'} />
																					<label htmlFor="radio3"> Face to Face </label>
																				</div>
																			</div>
																		</div>
																		<div className="col-md-4">
																			<div className="boxMrgB boxMrgT">
																				<div className="radio radio-primary">
																					<input type="radio" name="mode" id="radio4" onChange={this.onChange} value="2" checked={this.state.mode === '2'} />
																					<label htmlFor="radio4"> Online </label>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
																<div className="col-md-12 offset-md-0 offsettablet col-lg-6 offset-lg-3 col-xl-6 offset-xl-3">
																	<div className="row">
																		<div className="col-lg-2 col-md-3 xsdevice">
																			<div className="genderInfo ">Gender</div>
																		</div>
																		<div className="col-md-6 col-lg-5 xsdevice">
																			<div className="boxMrgB boxMrgT">
																				<div className="radio radio-primary">
																					{this.state.gender}
																					{/* <input type="radio" name="gender" id="radio1" value="Male" defaultChecked={this.state.gender === 'Male'} />
																					<label htmlFor="radio1"> Male </label> */}
																				</div>
																			</div>
																		</div>
																		{/* <div className="col-md-3 col-lg-4">
																			<div className="boxMrgB boxMrgT">
																				<div className="radio radio-primary">
																					<input type="radio" name="gender" id="radio2" value="Female" defaultChecked={this.state.gender === 'Female'} />
																					<label htmlFor="radio2"> Female </label>
																				</div>
																			</div>
																		</div> */}
																	</div>
																</div>

																<div className="col-lg-11 col-md-11 col-sm-10 col-xs-10">
																	<div className="input-group attachmentInfo">


																		{/* <textarea className="form-controltooltip-custom fadeEffect tisymtomhover icon bookdelete" data-title="What are your associated symptoms?
Please provide relevant details which could aid the specialist prior to your appointment." id="fake-file-input-name" placeholder="Symptoms" name='symptoms' style={customStyles.symptomsTxt} value={this.state.symptoms} onChange={this.onChange.bind(this)} defaultValue=" " /> */}

<textarea className="form-control"  id="fake-file-input-name" placeholder="Symptoms" name='symptoms' style={customStyles.symptomsTxt} value={this.state.symptoms} onChange={this.onChange.bind(this)} defaultValue=" " />


																		{/* <Modal
																		isOpen={this.state.modalIsOpen}
																		onRequestClose={this.closeModal}
																		style={customStyles}
																	>
																		<DocumentUpload closeModal={this.closeModal.bind(this)} userTypeData={this.state.userTypeData} onChange={this.onChange} documentName={this.state.documentName} documentTypeId={this.state.documentTypeId} uploadDocument={this.uploadDocument}
																			reSetModal={this.reSetModal} />
																	</Modal> */}

																	</div>



																</div>

																<div className="col-xs-2 col-sm-2 col-md-1 col-lg-1">
																			<div className="tooltip-custom fadeEffect posabr00 pull-right subRight helpsvg mobileposavr00" data-title="What are your associated symptoms?
Please provide relevant details which could aid the specialist prior to your appointment.">
																			<span>
																	          <SVGICONS.Helppic />
																            </span>																			</div>
																</div>

																<div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
																    <span className="input-group-btn">
																		<a id="fake-file-button-browse" className="uploadLink" onClick={this.openModal} >Upload Document</a>
																	</span>
																</div>

																<div className="box-body table-responsive no-padding attachmentTable">
																	<table className="table table-hover">
																		<tbody><tr>
																			<th>Document Name </th>
																			<th>  Document Type   </th>
																			<th>Document</th>
																			<th>Uploaded Date </th>
																			<th>Action</th>
																		</tr>
																			{uploadedImages.length > 0 ? uploadedImages.map((item, index) => <tr key={index}>
																				<td>{item.documentName}                                </td>
																				<td>{item.documentTypeId
																					.name} </td>
																				<td> <Link href="#" className="docLink">{item.documentOriginalName ? item.documentOriginalName : item.documentUrl}</Link>     </td>
																				<td>{moment(item.createdAt).format('DD-MMM-YYYY')}        </td>
																				<td>

																					<Link className="tooltip-custom fadeEffect tisymtomhover icon bookdelete" data-title="Documents" onClick={this.appointmentDocuments.bind(this, item)}><img src={require('../../images/img/book.png')} style={{ 'cursor': 'pointer' }} /></Link>

																					<Link onClick={this.deleteDocument.bind(this, item)} className="deleteLink"><i className="fa fa-trash"></i></Link></td>
																			</tr>) : <tr><td colSpan={5}>	<p className="text-center"> No Records</p></td></tr>}


																		</tbody></table>
																</div>
																<div className="col-md-12 text-center">
																	<div className="bottomBtn">
																		<button type="submit" className="btn btn-warning btn-lg" >Request Appointment {this.state.spinner == true ? <i className="fa fa-spinner fa-spin" /> : ""}</button>  <button type="button" onClick={this.cancelAppointment} className="btn btn-cancel btn-default btn-lg">Cancel</button>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</form>
												{this.state.docModal ? <AppointmentDocs openModal={this.state.docModal} hideConditionModal={this.hidedocModal} appointmentId={this.state.appointmentId} patientId={this.state.patientId} /> : ''}

												{this.state.openDocumentModal ? <DocumentUpload openDocumentModal={this.state.openDocumentModal} hideDocumentModal={this.hideDocumentModal} userTypeData={userTypeData} onChange={this.onChangeDocument} documentName={this.state.documentName} documentTypeId={this.state.documentTypeId} uploadDocument={this.uploadDocument} file={this.state.file} reSetModal={this.reSetModal} spinner={this.state.spinner}
													fileOriginalName={this.state.uploadedFileOriginalName}
												/> : ''}
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
				}

				<div className="Copyrightafterlogin">
				<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div >
		);
	}
}
// export default BookAppointment;
//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		appointmentDetails: state.appointment ? state.appointment.appointmentDetails : [],
		userTypeData: state.uploadDocument.userTypeData,
		uploadedImages: state.uploadDocument.uploadedImages
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		appointmentactions: bindActionCreators(appointmentActions, dispatch),
		actions: bindActionCreators(documentUploadActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(AppointmentDetails);
